import { SqliteJsonRepository } from './SqliteJsonRepository';
import type { Bulletin } from '@shared/types/Bulletin';

export class SqliteBulletinRepository extends SqliteJsonRepository<Bulletin> {
  constructor() {
    super('bulletins');
  }
}
